import { render, staticRenderFns } from "./OversightDashboard.vue?vue&type=template&id=0995e568&scoped=true&"
import script from "./OversightDashboard.vue?vue&type=script&lang=ts&"
export * from "./OversightDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0995e568",
  null
  
)

export default component.exports